export function getLocalStorage(key, defaultValue){
    try {
        const stickyValue = localStorage.getItem(key);
        return (stickyValue !== null && stickyValue !== 'undefined')
            ? JSON.parse(stickyValue)
            : defaultValue;
    } catch(error) {
        return defaultValue
    }    
}

export function setLocalStorage(key, value){
    try {
        localStorage.setItem(key, value)
    } catch(error) {
        
    }
}

export function removeFromLocalStorage(key){
    try {
        localStorage.removeItem(key)
    } catch(error) {
        
    }
}